module.exports = __webpack_public_path__ + "img/Anindya_Dutta-1-498x500.ce875dd2.png";